import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';

import { Card, CardBody, Button, ButtonGroup, CardHeader, CardSubtitle, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, Input, Label, Nav, NavItem, NavLink, Pagination, PaginationItem, PaginationLink, Progress, Row, TabContent, Table, TabPane, UncontrolledCollapse, UncontrolledDropdown, Spinner } from 'reactstrap';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import axiosInstance from '../../../../axiosConfig';
import Loader from '../../../../Components/Common/Loader';
import { toast, ToastContainer } from 'react-toastify';
import Key from '../../../../key';

function formatDateToYYYYMMDD ( dateString )
{
    const date = new Date( dateString ); // Convertir la chaîne de date en objet Date
    const year = date.getFullYear(); // Obtenir l'année
    const month = String( date.getMonth() + 1 ).padStart( 2, '0' ); // Obtenir le mois (ajouter 1 car Janvier = 0)
    const day = String( date.getDate() ).padStart( 2, '0' ); // Obtenir le jour

    return `${ year }-${ month }-${ day }`; // Retourner la date formatée
}
// const {  quillRef } = useQuill();

const AjouterEvenement = () =>
{
    const { id: eventId } = useParams();
    // evenements / add / 16
    const [ event_saved_id, set_event_saved_id ] = useState();
    const [ billetsEvent, setBilletsEvent ] = useState( [] );
    const [ activeAddTab, setActiveAddTab ] = useState( "1" );
    const [ loadingEventBillet, setLoadingEventBillet ] = useState( false );
    const [ eventBillet, setEventBillet ] = useState( [] );
    const [ loadingSaveBillet, setLoadingSaveBillet ] = useState( false );

    const fetchBilletsEvent = async ( idEvent ) =>
    {
        // evenment_list = await axiosInstance.get( `/eventgetallfororga` );
        const billet_event = await axiosInstance.get( `/billetgetforevent/?event_id=${ idEvent }` );
        // console.log( "billet_event: ", billet_event )
        const billetEventData = billet_event.data.data


        setEventBillet(
            billet_event.data ? billet_event.data.data : []
        )

        setLoadingEventBillet( false )
    }

    useEffect( () =>
    {
        if ( eventBillet.length > 0 )
        {
            setBilletsEvent(
                eventBillet.length > 0 ? eventBillet :
                    [ { categorie: '', montant: '', quantite: '', event_id: event_saved_id, color_billet: '' } ]
            );
        }
    }, [ eventBillet ] )

    const tabAddChange = ( tab ) =>
    {
        if ( activeAddTab !== tab ) setActiveAddTab( tab );
    };

    const [ activeUpdateTab, setActiveUpdateTab ] = useState( "1" );

    const tabUpdateChange = ( tab ) =>
    {
        if ( activeUpdateTab !== tab ) setActiveUpdateTab( tab );
    };

    const [ roleSession, setRoleSession ] = useState( "" )
    function getSessionData ()
    {
        if ( localStorage.getItem( "authUser" ) )
        {
            const obj = JSON.parse( localStorage.getItem( "authUser" ) );
            // console.log( 'obj localStorage:', obj )
            setRoleSession( obj.role )
        }
        setLoading( false )
    }

    useEffect( () =>
    {
        getSessionData()
    }, [] )

    const history = useHistory()
    // const logo = useRef(null);
    const [ logo, setLogo ] = useState( "" );
    const [ baniere, setBaniere ] = useState( "" )

    const [ logoDefault, setLogoDefault ] = useState( "" );
    const [ baniereDefault, setBaniereDefault ] = useState( "" )

    const today = new Date().toISOString().split( 'T' )[ 0 ];

    const [ publier, setPublier ] = useState( "RETIRER" )
    const [ nom, setNom ] = useState( "" );
    const [ description, setDescription ] = useState( "" );
    const [ date, setDate ] = useState( "" );

    const [ date_fin, setDate_fin ] = useState( "" );
    const [ heure_fin, setHeure_fin ] = useState( "" );
    const [ heure, setHeure ] = useState( "" );

    const [ lieu, setLieu ] = useState( "" );
    const [ categorie, setCategorie ] = useState( "Billetterie seule" );

    const [ numero, setNumero ] = useState( "" );
    const [ date_fin_vente, setDate_fin_vente ] = useState( "" );
    const [ loading, setLoading ] = useState( false );

    //******ici */


    const eventSubmit = async ( event ) =>
    {
        setLoading( true )
        event.preventDefault();
        try
        {
            console.log( "logo: ", logo , ' baniere: ', baniere, ' publier: ', publier, ' nom: ', nom, ' description: ', description, ' date: ', date, ' lieu: ', lieu, ' date_fin: ', date_fin, ' heure_fin: ', heure_fin, ' heure: ', heure, ' categorie: ', categorie, ' numero: ', numero, ' date_fin_vente: ', date_fin_vente )
            if ( nom &&
                description &&
                date &&
                lieu &&
                date_fin &&
                heure_fin &&
                heure &&
                categorie &&
                numero &&
                logo &&
                baniere &&
                publier )
            {

                // const logo = logo.current;
                // const banniere = banniere.current;

                const formData = new FormData();
                formData.append( 'nom', nom );
                formData.append( 'description', description );

                formData.append( 'date', date );
                formData.append( 'lieu', lieu );

                formData.append( 'date_fin', date_fin );
                formData.append( 'heure_fin', heure_fin );

                formData.append( 'heure', heure );
                formData.append( 'categorie', categorie );

                formData.append( 'numero', numero );
                formData.append( 'image', logo );
                formData.append( 'banniere', baniere );
                formData.append( 'publier', publier );
                formData.append( "date_fin_vente", date_fin_vente );

                console.log( "Mes informations", formData );
                const res = await axiosInstance.post( "/eventcreate/", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                } );

                // 201 pour une création, 200 par tolérance : l'écran ne
                // reconnaissait que 200 et affichait « Erreur lors de la
                // sauvegarde » sur un événement pourtant créé — d'où les
                // doublons quand l'utilisateur recommençait.
                if ( res.status === 200 || res.status === 201 )
                {
                    setLoadingEventBillet( true )
                    // Le serveur renvoie { data: { id } } ; « event_id » ne
                    // figure nulle part dans sa réponse.
                    const idCree = res.data?.data?.id ?? res.data?.event_id;
                    set_event_saved_id( idCree )
                    setActiveAddTab( "2" )
                    toast.success( ( "Evénement sauvegardé avec succès" ), {
                        autoClose: 3000,
                    } );

                    // setTimeout( () =>
                    // {
                    //     history.push( "/evenements" )
                    // }, 2000 )
                } else
                {
                    toast.error( ( "Erreur lors de la sauvegarde de l'evenement" ), {
                        autoClose: 3000,
                    } );
                }
            } else
            {
                toast.error( ( "Veuillez remplir tous les champs." ), {
                    autoClose: 3000,
                } );
            }

        } catch ( error )
        {
            toast.error( ( "Erreur lors de la sauvegarde de l'evenement" ), {
                autoClose: 3000,
            } );
            console.error( "erreur lors de l'envoie des données", error )
        }
        setLoading( false )
        setLoadingEventBillet( false )
    }

    const [ formCount, setFormCount ] = useState( 1 );

    useEffect( () =>
    {
        // console.log( "event_saved_id: ", event_saved_id )
        fetchBilletsEvent( event_saved_id );
    }, [ event_saved_id ] )

    const handleAddForm = () =>
    {
        setBilletsEvent( [ ...billetsEvent,
        {
            categorie: '',
            montant: '',
            quantite: '',
            event_id: event_saved_id,
            color_billet: ''
        } ] );
        setFormCount( formCount + 1 );
    };

    const handleRemoveForm = ( index ) =>
    {
        const newFormData = [ ...billetsEvent ];
        if ( Object.keys( newFormData ).length > 1 )
        {
            newFormData.splice( index, 1 );
            setBilletsEvent( newFormData );
            setFormCount( formCount - 1 );
        }
    };

    const handleChangeCategorieBillet = ( index, event ) =>
    {
        const { name, value } = event.target;
        // console.log( `name ${ name } ${ index }: `, value )
        const newFormData = [ ...billetsEvent ];
        // console.log( "newFormData: ", newFormData )
        newFormData[ index ][ name ] = value;
        setBilletsEvent( newFormData );
    };

    const [ isFormDataEmpty, setIsFormDataEmpty ] = useState( true )
    useEffect( () =>
    {
        // console.log( 'billetsEvent: ', billetsEvent )
        const isFormDataEmpty = billetsEvent.every( item =>
        {
            return (
                item.categorie !== "" && item.categorie !== null && item.categorie !== undefined
                &&
                item.montant !== "" && item.montant !== null && item.montant !== undefined
                &&
                item.quantite !== "" && item.quantite !== null && item.quantite !== undefined
                &&
                item.color_billet !== "" && item.color_billet !== null && item.color_billet !== undefined
            )
        } );

        // console.log( 'isFormDataEmpty: ', isFormDataEmpty )
        setIsFormDataEmpty( !isFormDataEmpty );
    }, [ billetsEvent ] );

    const eventBilletSubmit = async ( event ) =>
    {
        setLoadingSaveBillet( true )
        event.preventDefault();
        try
        {
            const isFormDataEmpty = billetsEvent.every( item =>
                Object.values( item ).every( value => value === '' || value === null || value === undefined )
            );
            // console.log( "billetsEvent: ", billetsEvent );

            if ( isFormDataEmpty )
            {
                console.error( "Il y a des champs vides..." )
            } else
            {
                // Enrégistrer les données
                console.log( "Enrégistrer les données..." )

                const res = await axiosInstance.post( "/billetcreate/", billetsEvent );
                console.log( "res billetcreate submit: ", res );
                if ( res.status === 200 )
                {
                    console.log( "res submit: ", res );
                    console.log( res.data );
                    set_event_saved_id( res.data.id )
                    fetchBilletsEvent( event_saved_id );
                    setActiveAddTab( "3" );
                    toast.success( ( "Billet.s de l'événement sauvegardé.s avec succès" ), {
                        autoClose: 3000,
                    } );
                } else
                {
                    toast.error( ( "Erreur lors de la sauvegarde de l'evenement" ), {
                        autoClose: 3000,
                    } );
                }
            }

        } catch ( error )
        {
            toast.error( ( "Erreur lors de la sauvegarde des billets de l'événement" ), {
                autoClose: 3000,
            } );
            console.error( "Erreur lors de la sauvegarde des billets de l'événement", error )
        }
        setLoadingSaveBillet( false )
    }


    const eventSubmitUpdate = async ( event ) =>
    {
        setLoading( true )
        event.preventDefault();
        try
        {
            // const logo = logo.current;
            // const banniere = banniere.current;
            const dataUpdate = {
                'nom': nom,
                'description': description,
                'date': date,
                'lieu': lieu,
                'date_fin': date_fin,
                'heure_fin': heure_fin,
                'heure': heure,
                'categorie': categorie,
                'numero': numero,
                'publier': publier,
                "date_fin_vente": date_fin_vente,

            }
            console.log( "dataUpdate: ", dataUpdate )

            // `id` dans le corps : le contrôleur y lit l'événement à modifier,
            // et rejetait la requête en 400 tant qu'il n'y figurait pas.
            const res = await axiosInstance.post( "/eventupdate/", {
                ...dataUpdate,
                id: eventId,
            } );
            if ( res.status === 200 )
            {
                console.log( "res submit: ", res );
                console.log( res.data );

                await fetchEventData();

                toast.success( ( "Evénement modifié avec succès" ), {
                    autoClose: 3000,
                } );

                setTimeout( () =>
                {
                    history.push( `/evenements/${ eventId } ` )
                }, 2000 )
            } else
            {
                toast.error( ( "Erreur lors de la modification de l'evenement" ), {
                    autoClose: 3000,
                } );
            }

        } catch ( error )
        {
            toast.error( ( "Erreur lors de la modification de l'evenement" ), {
                autoClose: 3000,
            } );
            console.error( "Erreur lors de la modification de l'événement", error )
        }
        setLoading( false )
    }

    const eventSubmitChangeLogo = async ( event ) =>
    {
        setLoading( true )
        event.preventDefault();
        try
        {
            // const logo = logo.current;
            // const banniere = banniere.current;

            const formData = new FormData();
            formData.append( 'image', logo );

            const res = await axiosInstance.post( `/eventupdatelogo/?event_id=${ eventId }`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            } );
            if ( res.status === 200 )
            {
                console.log( "res submit: ", res );
                console.log( res.data );

                toast.success( ( "Logo de l'événement modifé avec succès" ), {
                    autoClose: 3000,
                } );

                setTimeout( () =>
                {
                    history.push( `/evenements/${ eventId } ` )
                }, 2000 )
            } else
            {

                toast.error( ( "Erreur lors de la modification du logo de l'evenement" ), {
                    autoClose: 3000,
                } );
            }

        } catch ( error )
        {
            toast.error( ( "Erreur lors de la modification du logo de l'evenement" ), {
                autoClose: 3000,
            } );
            console.error( "erreur lors de la modification du logo de l'événement des données", error )
        }
        setLoading( false )
    }

    const eventSubmitChangeBanner = async ( event ) =>
    {
        setLoading( true )
        event.preventDefault();
        try
        {
            // const logo = logo.current;
            // const banniere = banniere.current;

            const formData = new FormData();
            formData.append( 'banniere', baniere );

            const res = await axiosInstance.post( `/eventupdatebanniere/?event_id=${ eventId }`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            } );
            if ( res.status === 200 )
            {
                console.log( "res submit: ", res );
                console.log( res.data );

                toast.success( ( "Banière de l'événement modifiée avec succès" ), {
                    autoClose: 3000,
                } );

                setTimeout( () =>
                {
                    history.push( `/evenements/${ eventId } ` )
                }, 2000 )
            } else
            {

                toast.error( ( "Erreur lors de la modification de la banière de l'événement" ), {
                    autoClose: 3000,
                } );
            }

        } catch ( error )
        {
            toast.error( ( "Erreur lors de la modification de la banière de l'événement" ), {
                autoClose: 3000,
            } );
            console.error( "Erreur lors de la modification de la banière de l'événement", error )
        }
        setLoading( false )
    }

    useEffect( () =>
    {
        return () =>
        {
            URL.revokeObjectURL( logo );
            URL.revokeObjectURL( baniere );
        };
    }, [ logo, baniere ] );

    const fetchEventData = useCallback( async () =>
    {
        try
        {
            const eventDetailResponse = await axiosInstance.get(
                `/eventgetone/?event_id=${ eventId }/`
            );
            console.log( "eventDetailResponse.data.data: ", eventDetailResponse.data.data )
            const event = ( eventDetailResponse.data.data );

            setPublier( event.publier )
            setNom( event.nom )
            setDescription( event.description )
            setDate( formatDateToYYYYMMDD( event.date ) )
            setDate_fin( formatDateToYYYYMMDD( event.date_fin ) )
            setDate_fin_vente( formatDateToYYYYMMDD( event.date_fin_vente ) )
            setHeure_fin( event.heure_fin )
            setHeure( event.heure )
            setLieu( event.lieu )
            setCategorie( event.categorie )
            setNumero( event.numero )

            setLogoDefault( event.logo )
            setBaniereDefault( event.banniere )

        } catch ( err )
        {
            console.error( "Échec de récupération des données: ", err );
            toast.error( "Échec de récupération des données." );
        }

        setLoading( false );
    }, [ eventId ] ); // Add eventId to the dependencies array

    useEffect( () =>
    {
        if ( eventId )
        {
            fetchEventData();
            console.log( "eventId useEffect: ", eventId )
            set_event_saved_id( eventId );
        }
    }, [ eventId, fetchEventData ] );

    //Dropzone file upload
    const [ selectedFiles, setselectedFiles ] = useState( [] );

    const handleAcceptedFiles = ( files ) =>
    {
        files.map( file =>
            Object.assign( file, {
                preview: URL.createObjectURL( file ),
                formattedSize: formatBytes( file.size ),
            } )
        );
        setselectedFiles( files );
    }

    /**
     * Formats the size
    */
    const formatBytes = ( bytes, decimals = 2 ) =>
    {
        if ( bytes === 0 ) return "0 Bytes";
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = [ "Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB" ];

        const i = Math.floor( Math.log( bytes ) / Math.log( k ) );
        return parseFloat( ( bytes / Math.pow( k, i ) ).toFixed( dm ) ) + " " + sizes[ i ];
    }

    document.title = eventId ? "Modifier événement | Takci" : "Ajouter événement | Takci";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb
                        title={ eventId ? "Modifier événement" : "Créer évènement" }
                        pageTitle="ÉVÉNEMENTS"
                        pageTitleLink="/evenements"
                    />

                    <Row>
                        <Card>
                            <CardHeader>
                                <Nav
                                    className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                                    role="tablist"
                                >
                                    <NavItem>
                                        <NavLink
                                            to="#"
                                            type="button"
                                            className={ classnames( { active: activeUpdateTab === "1" } ) }
                                            onClick={ () =>
                                            {
                                                tabUpdateChange( "1" );
                                            } }
                                        >
                                            <i className="fas fa-user"></i>
                                            { ( "Informations générales" ) }
                                        </NavLink>
                                    </NavItem>

                                    {
                                        eventId &&
                                        <>
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    className={ classnames( { active: activeUpdateTab === "2" } ) }
                                                    onClick={ () =>
                                                    {
                                                        tabUpdateChange( "2" );
                                                    } }
                                                    type="button"
                                                >
                                                    <i className="far fa-lock"></i>
                                                    { ( "Modifier l'image" ) }
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    to="#"
                                                    className={ classnames( { active: activeUpdateTab === "3" } ) }
                                                    onClick={ () =>
                                                    {
                                                        tabUpdateChange( "3" );
                                                    } }
                                                    type="button"
                                                >
                                                    <i className="far fa-shield-fill-exclamation"></i>
                                                    { ( "Modifier la banière" ) }
                                                </NavLink>
                                            </NavItem>
                                        </>
                                    }
                                </Nav>
                            </CardHeader>


                            <CardBody className="p-4">
                                <TabContent activeTab={ activeUpdateTab }>
                                    <TabPane tabId="1">
                                        <CardHeader>
                                            <Nav
                                                className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                                                role="tablist"
                                            >
                                                <NavItem>
                                                    <NavLink
                                                        to="#"
                                                        type="button"
                                                        className={ classnames( { active: activeAddTab === "1" } ) }
                                                        onClick={ () =>
                                                        {
                                                            tabAddChange( "1" );
                                                        } }
                                                        disabled={ !eventId }
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="text-success fs-4 rounded-circle">
                                                                <i className="ri-checkbox-circle-fill"></i>
                                                            </div>
                                                            { ( "Événement" ) }
                                                        </div>
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink
                                                        to="#"
                                                        className={ classnames( { active: activeAddTab === "2" } ) }
                                                        onClick={ () =>
                                                        {
                                                            tabAddChange( "2" );
                                                        } }
                                                        type="button"
                                                        disabled={ !eventId }
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="text-success fs-4 rounded-circle">
                                                                <i className="ri-checkbox-circle-fill"></i>
                                                            </div>
                                                            { ( "Tickets" ) }
                                                        </div>
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                        </CardHeader>

                                        <TabContent activeTab={ activeAddTab }>
                                            <TabPane tabId="1">
                                                <TabContent activeTab={ activeUpdateTab }>
                                                    <TabPane tabId="1">
                                                        <Form onSubmit={ eventId ? eventSubmitUpdate : eventSubmit }>
                                                            <Card>
                                                                <CardBody>


                                                                    <div className="mb-3">
                                                                        { baniere ? (
                                                                            <img
                                                                                src={ URL.createObjectURL( baniere ) }
                                                                                alt="event-baniere"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        ) :
                                                                            baniereDefault &&
                                                                            <img
                                                                                src={ Key.baniereURL + baniereDefault }
                                                                                alt="event-baniere"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        }
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">La banière</Label>
                                                                        <div className="">
                                                                            <Input
                                                                                type="file"
                                                                                required={ !eventId }
                                                                                className="form-control"
                                                                                accept="image/png, image/gif, image/jpeg"
                                                                                onChange={ ( e ) =>
                                                                                {
                                                                                    const file = e.target.files[ 0 ];
                                                                                    if ( file )
                                                                                    {
                                                                                        setBaniere( ( file ) ); // Générez une URL temporaire pour l'image
                                                                                        console.log( "onchange Baniere : ", file );
                                                                                    }
                                                                                } }
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        { logo ? (
                                                                            <img
                                                                                src={ URL.createObjectURL( logo ) }
                                                                                alt="event-logo"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        ) :
                                                                            logoDefault &&
                                                                            <img
                                                                                src={ Key.logoURL + logoDefault }
                                                                                alt="event-logo"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        }
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Le Logo</Label>
                                                                        <div className="">
                                                                            <Input
                                                                                className="form-control"
                                                                                type="file"
                                                                                accept="image/png, image/gif, image/jpeg"
                                                                                required={ !eventId }
                                                                                onChange={ ( e ) =>
                                                                                {
                                                                                    const file = e.target.files[ 0 ];

                                                                                    if ( file )
                                                                                    {
                                                                                        setLogo( ( file ) ); // Générez une URL temporaire pour prévisualiser
                                                                                        console.log( "Logo sélectionné :", file.name );
                                                                                    }
                                                                                } }
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-title-input">Nom de l'événement</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="project-title-input"
                                                                            placeholder="Entrer le nom de votre événement"
                                                                            value={ nom }
                                                                            required
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setNom( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-title-input">Catégorie de l'événement</Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="project-title-input"
                                                                            placeholder="Entrer la categorie de votre événement"
                                                                            value={ categorie }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setCategorie( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label">La description</Label>

                                                                        <Input
                                                                            type="textarea"
                                                                            className="form-control"
                                                                            name='description'
                                                                            id="labelInput"
                                                                            rows="2"
                                                                            required
                                                                            value={ description }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setDescription( e.target.value )
                                                                            } }
                                                                            onBlur={ ( e ) =>
                                                                            {
                                                                                setDescription( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Quand aura lieu l'évènement ?</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            type="date"
                                                                            required
                                                                            value={ date }
                                                                            min={ today }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setDate( e.target.value );
                                                                            } }
                                                                            onBlur={ ( e ) =>
                                                                            {
                                                                                setDate( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Heure de début de l'évènement</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            type="time"
                                                                            name='heure'
                                                                            required
                                                                            value={ heure }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setHeure( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">La date de cloture de l'évènement ?</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            name='date_fin'
                                                                            type='date'
                                                                            required
                                                                            value={ date_fin }
                                                                            min={ date }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setDate_fin( e.target.value )
                                                                            } }
                                                                            onBlur={ ( e ) =>
                                                                            {
                                                                                setDate_fin( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">La date de cloture de la vente de billet ?</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            name='date_fin_vente'
                                                                            type='date'
                                                                            required
                                                                            value={ date_fin_vente }
                                                                            min={ today }
                                                                            max={ date_fin }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setDate_fin_vente( e.target.value )
                                                                            } }
                                                                            onBlur={ ( e ) =>
                                                                            {
                                                                                setDate_fin_vente( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Heure de fin de l'évènement</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            type="time"
                                                                            name='heure_fin'
                                                                            required
                                                                            value={ heure_fin }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setHeure_fin( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Où aura lieu l'évènement ?</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            type="text"
                                                                            required
                                                                            value={ lieu }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setLieu( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Quel est le numéro à contacter ?</Label>
                                                                        <Input
                                                                            className="form-control"
                                                                            id="project-thumbnail-img"
                                                                            type="number"
                                                                            name='numero'
                                                                            required
                                                                            value={ numero }
                                                                            onChange={ ( e ) =>
                                                                            {
                                                                                setNumero( e.target.value )
                                                                            } }
                                                                        />
                                                                    </div>

                                                                    <Row>
                                                                        <Col md={ 12 }>
                                                                            <div className="text-center">
                                                                                <button
                                                                                    disabled={ loading }
                                                                                    type="submit"
                                                                                    className="btn btn-primary text-center"
                                                                                >
                                                                                    {
                                                                                        loading ?
                                                                                            <div className="d-flex justify-center">
                                                                                                <Spinner size={ "sm" } />
                                                                                                <span>
                                                                                                    chargement...
                                                                                                </span>
                                                                                            </div> :
                                                                                            <span>
                                                                                                { eventId ? "Modifier événement" : "Ajouter événement" }
                                                                                            </span>
                                                                                    }
                                                                                </button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Form>
                                                    </TabPane>
                                                    <TabPane tabId="2">
                                                        <Form onSubmit={ eventSubmitChangeLogo }>
                                                            <Card>
                                                                <CardBody>

                                                                    <div className="mb-3">
                                                                        { logo ? (
                                                                            <img
                                                                                src={ URL.createObjectURL( logo ) }
                                                                                alt="event-logo"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        ) :
                                                                            logoDefault &&
                                                                            <img
                                                                                src={ Key.logoURL + logoDefault }
                                                                                alt="event-logo"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        }
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Le Logo</Label>
                                                                        <div className="">
                                                                            <Input
                                                                                className="form-control"
                                                                                type="file"
                                                                                accept="image/png, image/gif, image/jpeg"
                                                                                required={ !eventId }
                                                                                onChange={ ( e ) =>
                                                                                {
                                                                                    const file = e.target.files[ 0 ];

                                                                                    if ( file )
                                                                                    {
                                                                                        setLogo( ( file ) ); // Générez une URL temporaire pour prévisualiser
                                                                                        console.log( "Logo sélectionné :", file.name );
                                                                                    }
                                                                                } }
                                                                            />

                                                                        </div>
                                                                    </div>

                                                                    <Row>
                                                                        <Col md={ 12 }>
                                                                            <div className="text-center">
                                                                                <button disabled={ loading || !logo } type="submit" className="btn btn-primary text-center">
                                                                                    {
                                                                                        loading ?
                                                                                            <div className="d-flex justify-center">
                                                                                                <Spinner size={ "sm" } />
                                                                                                <span>
                                                                                                    chargement...
                                                                                                </span>
                                                                                            </div> :
                                                                                            <span>
                                                                                                Modifier le logo
                                                                                            </span>
                                                                                    }
                                                                                </button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Form>
                                                    </TabPane>
                                                    <TabPane tabId="3">
                                                        <Form onSubmit={ eventSubmitChangeBanner }>
                                                            <Card>
                                                                <CardBody>

                                                                    <div className="mb-3">
                                                                        { baniere ? (
                                                                            <img
                                                                                src={ URL.createObjectURL( baniere ) }
                                                                                alt="event-baniere"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        ) :
                                                                            baniereDefault &&
                                                                            <img
                                                                                src={ Key.baniereURL + baniereDefault }
                                                                                alt="event-baniere"
                                                                                className="rounded-lg preview-image"
                                                                                style={ {
                                                                                    width: "120px",
                                                                                    height: "120px",
                                                                                } }
                                                                            />
                                                                        }
                                                                    </div>

                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="project-thumbnail-img">La banière</Label>
                                                                        <div className="">
                                                                            <Input
                                                                                type="file"
                                                                                required={ !eventId }
                                                                                className="form-control"
                                                                                accept="image/png, image/gif, image/jpeg"
                                                                                onChange={ ( e ) =>
                                                                                {
                                                                                    const file = e.target.files[ 0 ];
                                                                                    if ( file )
                                                                                    {
                                                                                        setBaniere( ( file ) ); // Générez une URL temporaire pour l'image
                                                                                        console.log( "onchange Baniere : ", file );
                                                                                    }
                                                                                } }
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <Row>
                                                                        <Col md={ 12 }>
                                                                            <div className="text-center">
                                                                                <button disabled={ loading || !baniere } type="submit" className="btn btn-primary text-center">
                                                                                    {
                                                                                        loading ?
                                                                                            <div className="d-flex justify-center">
                                                                                                <Spinner size={ "sm" } />
                                                                                                <span>
                                                                                                    chargement...
                                                                                                </span>
                                                                                            </div> :
                                                                                            <span>
                                                                                                Modifier la banière
                                                                                            </span>
                                                                                    }
                                                                                </button>
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Form>
                                                    </TabPane>
                                                </TabContent>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <Form onSubmit={ eventBilletSubmit }>
                                                    <Card>
                                                        <CardBody>
                                                            {
                                                                loadingEventBillet ?
                                                                    <div className="d-flex justify-center">
                                                                        <Spinner size={ "sm" } />
                                                                        <span>
                                                                            chargement...
                                                                        </span>
                                                                    </div> :
                                                                    <Row>

                                                                        {
                                                                            eventBillet.length > 0 ?
                                                                                "" :
                                                                                billetsEvent.length > 0 && billetsEvent.map( ( form, index ) =>
                                                                                {
                                                                                    return (
                                                                                        <Row className="g-2 justify-content-end" key={ index }>
                                                                                            <Col md={ 12 } className="">
                                                                                                <span className='fw-bold'>
                                                                                                    Billet { index + 1 } :
                                                                                                </span>
                                                                                            </Col>
                                                                                            <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                                                                                                <label htmlFor={ `categorie-${ index }` } className="form-label fs-7">
                                                                                                    Catégorie du billet :
                                                                                                </label>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    id={ `categorie-${ index }` }
                                                                                                    name={ `categorie` }
                                                                                                    placeholder={ `Nom de catégorie ${ index + 1 }` }
                                                                                                    required
                                                                                                    className="form-control"
                                                                                                    value={ form.categorie }
                                                                                                    onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                                                                                                <label htmlFor={ `quantite-${ index }` } className="form-label fs-7">
                                                                                                    Quantité :
                                                                                                </label>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    min="1"
                                                                                                    id={ `quantite-${ index }` }
                                                                                                    name={ `quantite` }
                                                                                                    required
                                                                                                    className="form-control"
                                                                                                    placeholder={ `Quantité de catégorie ${ index + 1 }` }
                                                                                                    value={ form.quantite }
                                                                                                    onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md={ 6 } lg={ 4 } xxl={ 3 }>
                                                                                                <label htmlFor={ `montant-${ index }` } className="form-label fs-7">
                                                                                                    Montant :
                                                                                                </label>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    min="100"
                                                                                                    id={ `montant-${ index }` }
                                                                                                    name={ `montant` }
                                                                                                    required
                                                                                                    className="form-control"
                                                                                                    placeholder={ `Montant de catégorie ${ index + 1 }` }
                                                                                                    value={ form.montant }
                                                                                                    onChange={ ( e ) => handleChangeCategorieBillet( index, e ) }
                                                                                                />
                                                                                            </Col>
                                                                                            <Col md={6} lg={4} xxl={3}>
                                                                                                <label htmlFor={`color_billet-${index}`} className="form-label fs-7">
                                                                                                    Couleur du Billet :
                                                                                                </label>
                                                                                                <input
                                                                                                    type="color"
                                                                                                    id={`color_billet-${index}`}
                                                                                                    name="color_billet"
                                                                                                    required
                                                                                                    className="form-control form-control-color"
                                                                                                    value={form.color_billet || "#000000"}
                                                                                                    onChange={e => handleChangeCategorieBillet(index, e)}
                                                                                                    style={{ height: 38, width: 70, padding: 0, border: 'none' }}
                                                                                                />
                                                                                            </Col>
                                                                                            {
                                                                                                !loadingSaveBillet &&
                                                                                                Object.keys( billetsEvent ).length > 1 &&
                                                                                                <Col md={ 6 } lg={ 4 } xxl={ 3 } className="text-end align-content-end">
                                                                                                    <button className="btn btn-danger" type="button" onClick={ () => handleRemoveForm( index ) }>
                                                                                                        Supprimer
                                                                                                    </button>
                                                                                                </Col>
                                                                                            }
                                                                                            {
                                                                                                Object.keys( billetsEvent ).length !== index + 1 ?
                                                                                                    <hr /> :
                                                                                                    <div className="mb-3" />
                                                                                            }
                                                                                        </Row>
                                                                                    )
                                                                                } ) }

                                                                        {
                                                                            !loadingSaveBillet &&
                                                                            <div className="text-center mb-3">
                                                                                <button disabled={ isFormDataEmpty } className={ `btn ${ !isFormDataEmpty ? "btn-outline-primary" : "btn-danger" }` } type="button" id="button-addon2" onClick={ handleAddForm }>
                                                                                    { !isFormDataEmpty ?
                                                                                        "Ajouter une catégorie"
                                                                                        : "Veuillez remplir les champs existants"
                                                                                    }
                                                                                </button>
                                                                            </div>
                                                                        }

                                                                        {
                                                                            !isFormDataEmpty &&
                                                                            <Col md={ 12 }>
                                                                                <div className="text-end">
                                                                                    <button disabled={ loadingSaveBillet } type="submit" className="btn btn-primary text-center">
                                                                                        {
                                                                                            loadingSaveBillet ?
                                                                                                <div className="d-flex justify-center">
                                                                                                    <Spinner size={ "sm" } />
                                                                                                    <span>
                                                                                                        chargement...
                                                                                                    </span>
                                                                                                </div> :
                                                                                                <span>
                                                                                                    Ajouter le{ Object.keys( billetsEvent ).length > 1 && "s" } billet{ Object.keys( billetsEvent ).length > 1 && "s" }
                                                                                                </span>
                                                                                        }
                                                                                    </button>
                                                                                </div>
                                                                            </Col>
                                                                        }
                                                                    </Row>
                                                            }
                                                        </CardBody>
                                                    </Card>
                                                </Form>
                                            </TabPane>

                                            <TabPane tabId="3">
                                                <Card>
                                                    <div className="text-center">
                                                        <div className="avatar-md mt-5 mb-4 mx-auto">
                                                            <div className="avatar-title bg-light text-success display-4 rounded-circle">
                                                                <i className="ri-checkbox-circle-fill"></i>
                                                            </div>
                                                        </div>
                                                        <h5>Bravo !</h5>
                                                        <p className="text-muted">
                                                            Evénements et tickets créés avec succès
                                                        </p>

                                                        <Link
                                                            to={ `/evenements/${ event_saved_id || "" }` }
                                                            className="btn btn-primary"
                                                        >
                                                            Voir l'événement
                                                        </Link>
                                                    </div>
                                                </Card>
                                            </TabPane>
                                        </TabContent>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Form onSubmit={ eventSubmitChangeLogo }>
                                            <Card>
                                                <CardBody>

                                                    <div className="mb-3">
                                                        { logo ? (
                                                            <img
                                                                src={ URL.createObjectURL( logo ) }
                                                                alt="event-logo"
                                                                className="rounded-lg preview-image"
                                                                style={ {
                                                                    width: "120px",
                                                                    height: "120px",
                                                                } }
                                                            />
                                                        ) :
                                                            logoDefault &&
                                                            <img
                                                                src={ Key.logoURL + logoDefault }
                                                                alt="event-logo"
                                                                className="rounded-lg preview-image"
                                                                style={ {
                                                                    width: "120px",
                                                                    height: "120px",
                                                                } }
                                                            />
                                                        }
                                                    </div>

                                                    <div className="mb-3">
                                                        <Label className="form-label" htmlFor="project-thumbnail-img">Le Logo</Label>
                                                        <div className="">
                                                            <Input
                                                                className="form-control"
                                                                type="file"
                                                                accept="image/png, image/gif, image/jpeg"
                                                                required={ !eventId }
                                                                onChange={ ( e ) =>
                                                                {
                                                                    const file = e.target.files[ 0 ];

                                                                    if ( file )
                                                                    {
                                                                        setLogo( ( file ) ); // Générez une URL temporaire pour prévisualiser
                                                                        console.log( "Logo sélectionné :", file.name );
                                                                    }
                                                                } }
                                                            />

                                                        </div>
                                                    </div>

                                                    <Row>
                                                        <Col md={ 12 }>
                                                            <div className="text-center">
                                                                <button disabled={ loading || !logo } type="submit" className="btn btn-primary text-center">
                                                                    {
                                                                        loading ?
                                                                            <div className="d-flex justify-center">
                                                                                <Spinner size={ "sm" } />
                                                                                <span>
                                                                                    chargement...
                                                                                </span>
                                                                            </div> :
                                                                            <span>
                                                                                Modifier le logo
                                                                            </span>
                                                                    }
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Form>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Form onSubmit={ eventSubmitChangeBanner }>
                                            <Card>
                                                <CardBody>

                                                    <div className="mb-3">
                                                        { baniere ? (
                                                            <img
                                                                src={ URL.createObjectURL( baniere ) }
                                                                alt="event-baniere"
                                                                className="rounded-lg preview-image"
                                                                style={ {
                                                                    width: "120px",
                                                                    height: "120px",
                                                                } }
                                                            />
                                                        ) :
                                                            baniereDefault &&
                                                            <img
                                                                src={ Key.baniereURL + baniereDefault }
                                                                alt="event-baniere"
                                                                className="rounded-lg preview-image"
                                                                style={ {
                                                                    width: "120px",
                                                                    height: "120px",
                                                                } }
                                                            />
                                                        }
                                                    </div>

                                                    <div className="mb-3">
                                                        <Label className="form-label" htmlFor="project-thumbnail-img">La bannière</Label>
                                                        <div className="">
                                                            <Input
                                                                type="file"
                                                                required={ !eventId }
                                                                className="form-control"
                                                                accept="image/png, image/gif, image/jpeg"
                                                                onChange={ ( e ) =>
                                                                {
                                                                    const file = e.target.files[ 0 ];
                                                                    if ( file )
                                                                    {
                                                                        setBaniere( ( file ) ); // Générez une URL temporaire pour l'image
                                                                        console.log( "onchange Baniere : ", file );
                                                                    }
                                                                } }
                                                            />
                                                        </div>
                                                    </div>

                                                    <Row>
                                                        <Col md={ 12 }>
                                                            <div className="text-center">
                                                                <button disabled={ loading || !baniere } type="submit" className="btn btn-primary text-center">
                                                                    {
                                                                        loading ?
                                                                            <div className="d-flex justify-center">
                                                                                <Spinner size={ "sm" } />
                                                                                <span>
                                                                                    chargement...
                                                                                </span>
                                                                            </div> :
                                                                            <span>
                                                                                Modifier la banière
                                                                            </span>
                                                                    }
                                                                </button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Form>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Row>
                    <ToastContainer closeButton={ false } />

                </Container>
            </div>
        </React.Fragment >
    );
};


export default AjouterEvenement;
